import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

import LoadingSpinner from '../shared/components/LoadingSpinner';

import { prepareValidationSchema } from './shared/data';
import { CLEAR_REDIRECT_TO, UPDATE_SCHEMA } from './shared/reducer';
import {
  NEW_PATH,
  VIEW_PATH,
  EDIT_PATH,
  PRO_VIEW_PATH,
  ROUTES,
} from './shared/routes';
import { useStateValue } from './shared/state';

import Submission from './components/Submission';
import Form from './components/Form';

const FormRenderer = ({ history, viewComponent = null }) => {
  const [
    {
      isNew,
      isReadOnly,
      redirectTo,
      redirecting,
      questions,
      hidden,
      required,
      submission,
    },
    dispatch,
  ] = useStateValue();
  const showViewPath = isReadOnly || (!isNew && !redirectTo);
  const showNewPath = !isReadOnly && isNew;

  const isAdvanceSurvey = submission.name.includes('employee_bravely_advance');

  // Handle Redirect State Change
  useEffect(() => {
    if (redirectTo) {
      if (ROUTES.includes(redirectTo)) {
        history.push(redirectTo);
      } else {
        document.location = redirectTo;
      }
    }
    return () => {
      dispatch({
        type: CLEAR_REDIRECT_TO,
      });
    };
  }, [redirectTo]);

  // Update Schema Validation when questions change
  useEffect(() => {
    dispatch({
      type: UPDATE_SCHEMA,
      validationSchema: prepareValidationSchema({
        questions,
        required,
        hidden,
      }),
    });
  }, [hidden, required]);

  // Redirecting
  if (redirecting) {
    return <LoadingSpinner dark={true} />;
  }

  return (
    <Switch>
      <Route
        key={'submission'}
        exact
        path={VIEW_PATH}
        render={() =>
          // Check for NEW (empty data set) and redirect to NEW_PATH for form
          // Use modified Form component for advance survey views
          (showNewPath && <Redirect to={NEW_PATH} />) ||
          (isAdvanceSurvey && <Form disableFields={true} />) ||
          viewComponent || <Submission />
        }
      />
      <Route
        key={'formEdit'}
        exact
        path={EDIT_PATH}
        render={() =>
          // Edit only if not READ ONLY
          (isReadOnly && <Redirect to={VIEW_PATH} />) || <Form />
        }
      />
      <Route
        key={'formNew'}
        exact
        path={NEW_PATH}
        render={() =>
          // Always start in VIEW_PATH, redirect for non-new forms
          (showViewPath && <Redirect to={VIEW_PATH} />) || <Form />
        }
      />
      <Route
        key={'proSubmission'}
        exact
        path={PRO_VIEW_PATH}
        render={() =>
          (isAdvanceSurvey && <Form disableFields={true} />) ||
          viewComponent || <Submission />
        }
      />
    </Switch>
  );
};

FormRenderer.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(FormRenderer);
